export default "__VITE_ASSET__CtxPS6BO__"